import {lazyRegister} from "@/Core/lazyRegister";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {AdminUserRole, ChangePasswordModel, DistributorFilterItem, UpdateUserModel, UserModel} from "@/models";
import {OptionModel} from "@components/Forms";

export class AdminService {
    static $inject = ['BaseApiFactory'];

    roleOptions: OptionModel[] = [
        {
            value: AdminUserRole.SuperAdmin,
            text: AdminUserRole.SuperAdmin
        },
        // {
        //     value: AdminUserRole.SalesAdmin,
        //     text: AdminUserRole.SalesAdmin
        // },
        {
            value: AdminUserRole.Cashier,
            text: AdminUserRole.Cashier
        },
        {
            value: AdminUserRole.CustomerService,
            text: AdminUserRole.CustomerService
        },
        {
            value: AdminUserRole.CustomerServiceAdmin,
            text: AdminUserRole.CustomerServiceAdmin
        },
        {
            value: AdminUserRole.Ecommerce,
            text: AdminUserRole.Ecommerce
        },
        {
            value: AdminUserRole.EcommerceAdmin,
            text: AdminUserRole.EcommerceAdmin
        },
        // {
        //     value: AdminUserRole.EcommerceTester,
        //     text: AdminUserRole.EcommerceTester
        // },
        {
            value: AdminUserRole.Dealer,
            text: AdminUserRole.Dealer
        }
    ];
    distributors: OptionModel[];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllAdministrators(query: object, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<UserModel[]>('/v2/api/user/list-by-query', query, cancelToken);
    }

    public InsertUser(value: UpdateUserModel, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.post<boolean>('/v2/api/user/create', value, cancelToken, cancelToken);
    }

    public changePassword(accessToken: string, value: ChangePasswordModel, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put<boolean>('/v2/api/user/password', value, cancelToken,
            {
                accessToken
            });
    }

    public UpdateAdmin(value: UpdateUserModel, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put<boolean>('/v2/api/user/update', value, cancelToken);
    }

    public UpdateLoockStatus(value: {
        id: number,
        isLocked: number
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put<boolean>('/v2/api/user/update-status', value, cancelToken);
    }

    public Delete(id: number, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.delete<boolean>(`/v2/api/user/delete/${id}`, cancelToken);
    }
}

lazyRegister.service('AdminService', AdminService);
